import type { IRawDimTeam } from '@skystone/shared';
import { rawDimTeamApi } from '@/services/raw-dim-team-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const teamColumns: ColumnDef<IRawDimTeam>[] = buildRawColumns<IRawDimTeam>([
  { key: 'id', header: 'ID' },
  { key: 'teamKey', header: 'Team Key' },
  { key: 'teamId', header: 'Team ID' },
  { key: 'teamName', header: 'Team Name' },
  { key: 'productId', header: 'Product ID' },
  { key: 'regionName', header: 'Region Name' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblDimTeamPage() {
  const { data: rows, loading, error } = useApi(() => rawDimTeamApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - dim_team" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={teamColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('dim_team')}
      />
    </PageContainer>
  );
}
